export class AddToCartResultModel {
    succeeded: AddToCartItemResultModel[];
    failed: AddToCartItemResultModel[];
}

export interface AddToCartItemResultModel {
    productCode: string;
    quantity: number;
    error: string;
}